<div class="lc-stock-toolbar-wrap">
  <div class="lc-stock-toolbar">
    <div class="lc-stock-toolbar__search input-group form-password-toggle">
      <input
        type="text"
        class="form-control"
        [placeholder]="searchPlaceholder"
        aria-label="Recherche"
        [(ngModel)]="searchTerm"
        (ngModelChange)="onSearch()"
      />
      <div class="input-group-append">
        <span class="input-group-text">
          <i data-feather="search" [size]="20"></i>
        </span>
      </div>
    </div>

    <ng-select
      [id]="establishmentSelectId"
      class="lc-stock-establishment-select filter-ng-select pos-toolbar-ng-select"
      [items]="establishmentOptions"
      bindLabel="label"
      bindValue="id"
      [multiple]="true"
      [clearable]="true"
      [searchable]="true"
      [closeOnSelect]="false"
      [maxSelectedItems]="3"
      placeholder="Tous les établissements"
      [(ngModel)]="selectedEstablishmentIds"
      (change)="onEstablishmentChange()"
      appendTo="body"
    >
    </ng-select>

    <ng-select
      [id]="warehouseSelectId"
      class="lc-stock-warehouse-select filter-ng-select pos-toolbar-ng-select"
      [items]="warehouseOptions"
      bindLabel="label"
      bindValue="id"
      [multiple]="true"
      [clearable]="true"
      [searchable]="true"
      [closeOnSelect]="false"
      [maxSelectedItems]="3"
      [placeholder]="selectedEstablishmentIds.length ? 'Entrepôts de l’établissement' : 'Tous les entrepôts'"
      [(ngModel)]="selectedWarehouseIds"
      (change)="onWarehouseChange()"
      appendTo="body"
    >
    </ng-select>

    <button
      type="button"
      class="btn btn-outline-primary btn-sm lc-stock-toolbar__filter-btn"
      (click)="showBoundsPanel = !showBoundsPanel"
      [class.active]="showBoundsPanel"
      rippleEffect
    >
      <i data-feather="filter" [size]="16" class="mr-50"></i>
      Filtres stock
    </button>
  </div>

  <div class="lc-stock-bounds" [class.lc-stock-bounds--open]="showBoundsPanel">
    <div class="lc-stock-bounds__inner">
      <label>Stock physique min.</label>
      <input
        type="number"
        class="form-control form-control-sm"
        [(ngModel)]="stockPhysMinInput"
        placeholder="Min"
      />
      <label>Stock physique max.</label>
      <input
        type="number"
        class="form-control form-control-sm"
        [(ngModel)]="stockPhysMaxInput"
        placeholder="Max"
      />
      <button type="button" class="btn btn-primary btn-sm" (click)="applyBounds()">Appliquer</button>
      <button type="button" class="btn btn-outline-secondary btn-sm" (click)="resetBounds()">Réinitialiser</button>
    </div>
  </div>

  <div class="lc-stock-active-filters active-filters-container">
    <ng-container *ngIf="getActiveFilters().length > 0; else filtersPlaceholder">
      <div
        *ngFor="let filter of getActiveFilters(); trackBy: trackByFilterKey"
        class="filter-badge"
      >
        <span class="filter-badge-label">{{ filter.label }}:</span>
        <span class="filter-badge-value">{{ filter.value }}</span>
        <button
          type="button"
          class="filter-badge-close"
          (click)="removeFilter(filter.key, filter.optionValue, $event)"
          aria-label="Supprimer le filtre"
        >
          <i data-feather="x" style="width: 12px; height: 12px;"></i>
        </button>
      </div>
    </ng-container>
    <ng-template #filtersPlaceholder>
      <span class="lc-stock-filters-placeholder">&nbsp;</span>
    </ng-template>
  </div>
</div>
